import React, { useState, useEffect} from 'react';
import { Formik } from 'formik';
import tz from './tz';
import {connect} from 'react-redux';
import { withRouter } from 'react-router'
import {saveUserPreference, getUserPreferences} from '../../actions/userPreference';
import { Link, Switch, Route } from "react-router-dom";

function UserPreference ({dispatch, token,userId, preference, history}){


    useEffect(()=>{
        //fetch existing then set values
        dispatch(getUserPreferences(userId,token));
    },[])

    useEffect(()=>{
        if(preference && preference.value){
            const tzString = tz.filter( tzz => {
                if(tzz.label === preference.name){
                    setPref(tzz);
                }
            });
        }
    },[preference])

    const [pref, setPref] = useState();
    const breadCrumb = () => {
        let breadCrumb = window.location.href.split("/");
        return breadCrumb;
      }
    return(

        <div className="working-area-content">
            <div className="component-title list-group" id="working-area">
                <div className="list-group-item list-group-item-action gradient-background">
                    <div className="" id="endpoint-label-wrapper">
                        <div className="float-left breadcrumbs">
                            <div className="">
                                <p>
                                    <Link to={"/"}>
                                        <i className="fas fa-th"></i>
                                    </Link>
                                    <i className="fas fa-arrow-right"></i>
                                    <Link to={`/${breadCrumb()[3]}`}>
                                        User Preferences
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
              <div className="change-password-form-wrapper">
            <Formik
                initialValues={
                    { 
                        value: pref?pref.label:'',
                        user_id: userId,
                        name: ''
                    }
                }
                enableReinitialize={true}
                onSubmit={(values) => {
                    
                    const tzVal = tz.filter( t => {
                        if(t.label === values.value){
                            return t
                        }
                    });

                    //set the timezone value to Formik's value
                    values.value = tzVal ? tzVal[0].value : '';
                    values.name = tzVal ? tzVal[0].label : '';

                    dispatch(saveUserPreference(values,token,history))
                }}
                >
                {({ values,
                    handleChange,
                    handleSubmit,
                    handleBlur
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label >Timezone</label>
                            <select
                                name="value"
                                className="form-control"
                                value={values.value}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ display: 'block' }}
                            >
                                <option value="" label="Select timezone..."/>
                                {tz.map((item, i) => {
                                    return(
                                        <option value={item.label}>{item.label} </option>
                                    )
                                })}
                            </select>
                        </div>
                        <button type="submit" className="btn btn-primary">Save</button>
                    </form>
                )}
            </Formik>
            </div>
            </div>
        </div>
    )
}
function mapStateToProps(state){
    return{
        token: state.auth.access_token,
        userId: state.auth.user.id,
        preference: state.userpreference.preference
    }
}

function mapDispatchToProp(dispatch){
    return{
        dispatch: dispatch
    }
}

export default withRouter(connect(mapStateToProps,mapDispatchToProp)(UserPreference));


// WEBPACK FOOTER //
// ./src/pages/UserPreference/index.js